import { helper } from "@/shared/services/helper";
import store from "@/store";
const authUser =  store.getters.stateUser;
const siteSettings =  store?.getters?.siteSettings;

const regexMap = {
    passwordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)[A-Za-z\d\W_]+$/,
    referCodeRegex : /^\d+$/,
    passwordUpperCaseRegex : /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d]+$/    ,
    userRegex : /^(?=.*?[A-Za-z])(?=.*?[0-9])(?!.*\s)[A-Za-z0-9]{6,25}$/,
    referCodeRegex : /^[a-zA-Z0-9]+$/,
    withdrawPasswordRegex: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]+$/,
};

const validate = {
    areFieldsValid(type, prop, prop2, prop3, prop4, prop5, prop6, prop7, prop8) {
        const errorObj = {};
    
        const addError = (type, error, lang) => {
            if (!errorObj[type]) {
                errorObj[type] = [];
            }
            errorObj[type].push({ error, lang });
        };
    
        const validateMobile = (mobile) => {
            if (mobile?.length !== 10) {
                addError('mobile', 'Mobile Number Should Be Of 10 Digits.', 'mobile-number-should-be-of-10-digits');
            }
        };
        const validatePassword = (password) => {
            if (password.length < 8) {
                addError('password', 'Password Must Be Of Minimum 8 Characters And Maximum 20 Characters.', 'pass-min-8-max-20');
            }
            if (!helper.testRegex(regexMap.passwordRegex, password)) {
                addError('password', 'Password Must Contain Alphabets, Numbers, And At Least 1 In Capital Case, And 1 In Lower Case.', 'password-valid-msg');
            }
        };

         //Self Password
        const validateSelfPassword = (password) => {
            if (!password?.length) {
                addError('selfPassword', 'Please Enter Self Password', 'please-enter-self-password');
            }
            // if (!helper.testRegex(regexMap.passwordRegex, password)) {
            //     addError('selfPassword', 'Self Password Must Contain Alphabets, Numbers, And At Least 1 In Capital Case.', 'pass-alpha-num-1-caps');
            // }
        };

         // Withdraw password
         const validateWithdrawPassword = (password) => {
            if (password.length < 8) {
                addError('withdrawPassword', 'Password Must Be Of Minimum 8 Characters And Maximum 20 Characters.', 'pass-min-8-max-20');
            }
            if (!helper.testRegex(regexMap.withdrawPasswordRegex, password)) {
                addError('withdrawPassword', 'Password Must Contain Alphabets, Numbers, special characters And At Least 1 In Capital Case, And 1 In Lower Case.', 'password-valid-msg');
            }
        };

    
        const checkPasswordMatch = (password, confirmPassword) => {
            if (password !== confirmPassword) {
                addError('confirmPassword', 'Password Mismatch.', 'password-mismatch');
            }
        };

        const checkWithdrawPasswordMatch = (password, confirmPassword) => {
            if (password !== confirmPassword) {
                addError('confirmWithdrawPassword', 'Password Mismatched.', 'password-mismatched');
            }
        };
    
        // Validation for each auth type

        if (type == 'only-mobile') {
            const mobile = prop;
            validateMobile(mobile);
        }

        if (type === 'login') {
            const tab = prop, mobile = prop2, userId = prop3, password = prop4;
            if (tab == 1 && mobile === '') {
                addError('mobile', 'Please Enter Mobile Number', 'please-enter-mobile-number');
            }
            if (tab == 2 && userId === '') {
                addError('userId', 'Please Enter User ID', 'please-enter-user-name');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            }
        }
        
        if (type === 'signup') {
            const mobile = prop, otp = prop2, userId = prop3, password = prop4, confirmPassword = prop5;
            validateMobile(mobile);
            if (otp == '' && otp?.length == 0) {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp != '' && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'otp-6-digit-msg');
            }
            if (userId && userId.length < 6 || userId.length > 25) {
                addError('userId', 'User ID Must be between 6 to 25 Characters.', 'userid-must-contain-alphanumeric-and-between-6-to-25-characters');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (confirmPassword != '') {
                checkPasswordMatch(password, confirmPassword);
            }
        }
    
        if (type === 'forgot-password') {
            const mobile = prop, otp = prop2, password = prop3, confirmPassword = prop4;
            validateMobile(mobile);
            if (otp == '' && otp?.length == 0) {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp != '' && otp?.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'otp-6-digit-msg');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (confirmPassword !== '') {
                checkPasswordMatch(password, confirmPassword);
            }
        }
    
        if (type === 'change-password') {
            const oldPassword = prop, newPassword = prop2, confirmPassword = prop3, withdrawPassword = prop4, confirmWithdrawPassword = prop5, last_login_at = prop6, business_type = prop7, isPhone = prop8;
            if (oldPassword === '') {
                addError('oldPassword', 'Please Enter Current Password', 'please-enter-old-password');
            }
            if (newPassword === '') {
                addError('password', 'Please Enter New Password', 'please-enter-new-password');
            } else {
                validatePassword(newPassword);
            }
            if (newPassword !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (newPassword !== '' && confirmPassword !== '') {
                checkPasswordMatch(newPassword, confirmPassword);
            }

            // withdraw pass
            if(business_type == 2 && !last_login_at && !isPhone) {
                if (withdrawPassword === '') {
                    addError('withdrawPassword', 'Please Enter Withdraw Password', 'please-enter-withdraw-password');
                } else {
                    validateWithdrawPassword(withdrawPassword);
                }
                if (withdrawPassword !== '' && confirmWithdrawPassword === '') {
                    addError('confirmWithdrawPassword', 'Please Enter Confirm Withdraw Password', 'please-enter-confirm-password');
                }
                if (withdrawPassword !== '' && confirmWithdrawPassword !== '') {
                    checkWithdrawPasswordMatch(withdrawPassword, confirmWithdrawPassword);
                }
            }

        }

          // Withdraw password
          if (type === 'withdraw-password') {
            const otp = prop, withdrawPassword = prop2, confirmWithdrawPassword = prop3;
            if (otp === '') {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (otp != '' && otp.length != 6) {
                addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
            }
            // withdraw pass
            if (withdrawPassword === '') {
                addError('withdrawPassword', 'Please Enter Withdraw Password', 'please-enter-withdraw-password');
            } else {
                validateWithdrawPassword(withdrawPassword);
            }
             if (withdrawPassword !== '' && confirmWithdrawPassword === '') {
                addError('confirmWithdrawPassword', 'Please Enter Confirm Withdraw Password', 'please-enter-confirm-password');
            }
            if (withdrawPassword !== '' && confirmWithdrawPassword !== '') {
                checkWithdrawPasswordMatch(withdrawPassword, confirmWithdrawPassword);
            }
        }

        // affiliate
        if (type === 'affiliate') {
            const mobile = prop, otp = prop2, userId = prop3, password = prop4, confirmPassword = prop5, selfPassword = prop6;
            validateMobile(mobile);
            if (mobile?.length && otp?.filter(item => item == '')?.length == 6) {
                addError('otp', 'Please Enter OTP', 'please-enter-otp');
            }
            if (mobile?.length && otp?.filter(item => item == '')?.length != 6 && !otp?.every(item => item != '')) {
                addError('otp', 'Please Enter 6 Digit OTP', 'please-enter-otp-6');
            }
            if (userId === '') {
                addError('userId', 'Please Enter User ID', 'please-enter-user-name');
            } else if (userId && (userId?.length < 6 || userId?.length > 25)) {
                addError('userId', 'User ID Must Be Between 6 To 25 Characters', 'user-id-6-to-25');
            }
            if (password === '') {
                addError('password', 'Please Enter Password', 'please-enter-password');
            } else {
                validatePassword(password);
            }
            if (password !== '' && confirmPassword === '') {
                addError('confirmPassword', 'Please Enter Confirm Password', 'please-enter-confirm-password');
            }
            if (password !== '' && confirmPassword !== '') {
                checkPasswordMatch(password, confirmPassword);
            }
            if (selfPassword === '') {
                addError('selfPassword', 'Please Enter Self Password', 'please-enter-self-password');
            } else {
                validateSelfPassword(selfPassword);
            }
        }
    
        return errorObj;
    }
    
    
};
export default validate;